import { render } from "./AreaChart.vue?vue&type=template&id=74d1a912&scoped=true"
import script from "./AreaChart.vue?vue&type=script&lang=js"
export * from "./AreaChart.vue?vue&type=script&lang=js"

import "./AreaChart.vue?vue&type=style&index=0&id=74d1a912&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d1a912"]])

export default __exports__